import styled from 'styled-components'
/* es-lint-disable */

export const OverlapOuter = styled.div`
  .mobile-none {
    @media only screen and (max-width: 500px) {
      display: none;
    }
  }
  ${({ bgColor }) => (bgColor ? `color: black` : `color: white`)};
  @media only screen and (min-width: 906px) {
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ full, theme, bgColor, bgPct }) =>
      !full
        ? `background: linear-gradient(
      90deg,
      ${bgColor || theme.colors.overlap} ${bgPct || '70%'},
      white 35%
    );`
        : `background-color: ${theme.colors.overlap}`}
  }
  @media only screen and (max-width: 906px) {
    background: none;
    background-color: ${({ theme, bgColor }) =>
      bgColor || theme.colors.overlap};
    margin: 0 auto;
  }
`

export const OverlapWrapper = styled.section`
  display: flex;
  width: 100%;
  max-width: ${({ blockW }) => blockW || `1300px`};

  justify-content: space-around;
  align-items: center;
  @media only screen and (max-width: 1170px) {
    justify-content: center;
    align-items: center;
    background-color: ${({ theme, bgColor }) =>
      bgColor || theme.colors.overlap};
  }
  @media only screen and (max-width: 905px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 23px;
    box-sizing: border-box;
    margin-bottom: ${({ landing, full }) => (landing || full ? `0` : `6rem`)};
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  ${({ textMax }) => textMax && `max-width:${textMax};`}
  ${({ landing }) => landing && `align-items: center;`}
  width: 100%;
  padding: 5% ${({ rightPad }) => rightPad || `180px`} 4% 40px;
  ${({ noPad }) => noPad && `padding: 36px 0 36px 36px;`}
  > h3 {
    font-size: 49px;
    white-space: pre-line;
    ${({ landing }) => landing && `text-align: center;`}
    @media only screen and (max-width: 1200px) {
      font-size: 40px;
    }
    @media only screen and (max-width: 600px) {
      font-size: 30px;
    }
  }
  .paras {
    margin-top: 20px;
    font-size: 21px;
    @media only screen and (max-width: 700px) {
      font-size: 19px;
    }
    line-height: 2rem;
    > p {
      line-height: 2rem;
      margin-bottom: 22px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  > h3,
  p {
    max-width: ${({ full }) => (full ? `100%` : `100%`)};
  }

  @media only screen and (max-width: 1170px) {
    padding: 80px ${({ rightPad }) => rightPad} 80px 3rem;
  }
  @media only screen and (max-width: 905px) {
    padding: 64px 0 ${({ full }) => (full ? `38px` : `0`)};
  }
  @media only screen and (max-width: 600px) {
    > p {
      font-size: 19px;
    }
    ${({ full }) => full && `padding: 64px 0 38px;`}
  }
`

export const OverlapBottom = styled.div`
  padding-top: 2.8rem;
  display: flex;
  justify-content: ${({ buttonPos }) => (buttonPos ? buttonPos : 'center')};

  @media only screen and (max-width: 593px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .cta {
    &:first-child {
      margin-right: 3%;
      @media only screen and (max-width: 593px) {
        margin-right: 0;
        margin-bottom: 30px;
      }
    }
  }
`

export const ImgWrapper = styled.div`
  max-width: ${({ maxWidth }) => maxWidth}px;
  max-height: ${({ maxHeight }) => maxHeight}px;
  width: 100%;
  height: 100%;
  z-index: 10;
  margin: ${({ imgMargin }) => imgMargin};
  @media only screen and (min-width: 1278px) {
  }
  @media only screen and (max-width: 1170px) {
    margin: 42px;
  }

  @media only screen and (max-width: 905px) {
    margin: 0;
    margin-top: 10%;
    margin-bottom: -10%;
    box-sizing: border-box;
  }
`
